import React from 'react';
import './ImageLightbox.css';

export default function ImageLightbox({ src, onClose }) {
  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose}>✕</button>
      <img src={src} alt="" onClick={(e) => e.stopPropagation()} />
    </div>
  );
}
